<section role="region" class="cej-what-it-is">
  <article class="cej-what-it-is__article">
    <ng-container *ngIf="desktopIllustration$ | async as illustration">
      <img
        class="cej-what-it-is__article__image"
        [src]="illustration.src | imaginarySrc: 1:illustration.width"
        [srcset]="illustration.src | imaginarySrc: 4:illustration.width"
        alt=""
        role="presentation"
      />
    </ng-container>
    <aside class="cej-what-it-is__article__content">
      <h2 role="heading" class="cej-what-it-is__article__title">
        Le Contrat d&apos;Engagement Jeune, qu&apos;est-ce que c&apos;est&nbsp;?
      </h2>
      <h3 class="cej-what-it-is__article__subtitle">
        <em class="cej-what-it-is__article__subtitle__emphasis">
          Un parcours entièrement personnalisé qui peut durer de 6 à 12 mois*
        </em>
        en fonction de mon profil, pour m&apos;aider à définir mon projet professionnel et à trouver un emploi.
      </h3>
      <p class="cej-what-it-is__article__advantage_list-title">Quand je signe mon contrat, je bénéficie de&nbsp;:</p>
      <ul class="cej-what-it-is__article__advantage_list">
        <li class="cej-what-it-is__article__advantage_list__item">
          <em class="cej-what-it-is__article__advantage_list__emphasis">
            Un accompagnement personnalisé avec un conseiller dédié
          </em>
          qui me suit tout au long de mon parcours et jusqu&apos;à ce que j&apos;accède à un emploi durable
        </li>
        <li class="cej-what-it-is__article__advantage_list__item">
          <em class="cej-what-it-is__article__advantage_list__emphasis">Un programme intensif</em>
          de 15 à 20 heures par semaine composé de différents types d&apos;activités
        </li>
        <li class="cej-what-it-is__article__advantage_list__item">
          <em class="cej-what-it-is__article__advantage_list__emphasis">
            Une allocation pouvant aller jusqu&apos;à 500 euros par mois
          </em>
          en fonction de mes ressources et à condition que je respecte mes engagements
        </li>
      </ul>
      <p>* La durée de l&apos;accompagnement peut exceptionnellement aller jusqu&apos;à 18 mois</p>
      <ng-container *ngIf="mobileIllustration$ | async as illustration">
        <img
          class="cej-what-it-is__article__image"
          [src]="illustration.src | imaginarySrc: 1:illustration.width"
          [srcset]="illustration.src | imaginarySrc: 4:illustration.width"
          alt=""
          role="presentation"
        />
      </ng-container>
    </aside>
  </article>
</section>
